import { RejectTheDocumentQueryType } from '@/common/queries/rejectTheDocument/rejectTheDocumentQuery.type';
import { rejectTheDocumentQueryFunction } from '@/common/queries/rejectTheDocument/rejectTheDocumentQueryFunction';
import { MutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

export const rejectTheDocumentQueryOptions = (
  param: RejectTheDocumentQueryType,
): MutationOptions<
  AxiosResponse<any, any>,
  Error,
  RejectTheDocumentQueryType
> => ({
  mutationKey: ['reject-doc', param?.id, param?.description],
  mutationFn: () => rejectTheDocumentQueryFunction(param),
});
